module.exports = "https://static.wanderu.com/static/media/google-badge.86d7c822.png";